import * as Yup from 'yup'

import { formValidation } from '../../../FormLegacy/validation'
import { EMAIL_REGEX } from '../../../../helpers/constants'

export const createValidationSchema = (t, isGuestModal) =>
  Yup.object().shape({
    resident: isGuestModal
      ? Yup.string().required(t('visitors:form.residentRequired'))
      : Yup.string(),
    visitorName: Yup.string().required(t('visitors:form.visitorNameRequired')),
    // Declared so the conditional .when() rules below can resolve them — Yup only reads
    // sibling fields that exist in the shape, otherwise the condition silently evaluates false.
    keyAccess: Yup.boolean(),
    pinCode: Yup.boolean(),
    visitorPhone: Yup.string().when('keyAccess', {
      is: (keyAccess) => keyAccess,
      then: formValidation.phone,
      otherwise: formValidation.phoneNotRequired,
    }),
    visitorEmail: Yup.string().when(['keyAccess', 'pinCode'], {
      is: (keyAccess, pinCode) => keyAccess || pinCode,
      then: formValidation.email,
      otherwise: Yup.string().matches(EMAIL_REGEX, t('visitors:form.invalidEmailFormat')),
    }),
    visitorId: Yup.string().max(10, t('visitors:form.visitorIdTooLong')),
    permissionType: Yup.object().shape({
      id: Yup.string(),
    }),
    timeStart: Yup.string().when('permissionType.id', {
      is: (val) => ['custom', 'daily', 'weekly', 'monthly'].includes(val),
      then: Yup.string().required(t('visitors:form.startTimeRequired')),
    }),
    timeEnd: Yup.string().when('permissionType.id', {
      is: (val) => ['custom', 'daily', 'weekly', 'monthly'].includes(val),
      then: Yup.string()
        .required(t('visitors:form.endTimeRequired'))
        .test('is-after-start', t('visitors:form.endTimeMustBeAfterStart'), function (value) {
          const { timeStart } = this.parent
          if (!value || !timeStart) return true
          const end = new Date(value)
          const start = new Date(timeStart)
          return end > start
        }),
    }),
    dueDate: Yup.string().when('permissionType.id', {
      is: 'custom',
      then: Yup.string().required(t('visitors:form.dueDateRequired')),
    }),
    selectedDays: Yup.array().when('permissionType.id', {
      is: 'weekly',
      then: Yup.array().min(1, t('visitors:form.selectDaysRequired')),
    }),
    monthlyPermission: Yup.string().when('permissionType.id', {
      is: 'monthly',
      then: Yup.string().required(t('visitors:form.monthlyPermissionRequired')),
    }),
  })
